import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { authServices } from '../authServices'
import { ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useLogout = (options?: IOptionsUseMutation<any>) => {
  const { t } = useTranslation()

  return useMutation<any, ErrorDetail, void>({
    mutationFn: authServices.logout,
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      const errorMessage = t('api:errors.somethingWrong')

      if (options?.onError) {
        options.onError({ ...err, errorMessage, code })
      }
    },
  })
}
